import React, { useCallback, useEffect, useState } from 'react';
import "./Flowchart.scss"
// import ComingSoon from "../../components/ComingSoon"
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import CustomNode from '../../components/Nodes/CustomNode';

import ModalEmpleado from '../../components/Modales/Flowchart/ModalEmpleado';

import { jwtDecode } from "jwt-decode"
import { useAdmin } from '../../context/AdminContext';

const nodeTypes = {
  custom: CustomNode
};

export const flowchartContext = React.createContext()

function Flowchart() {

  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const USER = jwtParse.apirest.objeto

  const { consultoras, fetchConsultoras } = useAdmin()

  const [modalEmpleado, setModalEmpleado] = useState(false)
  const [idEmpresaFlow, setIdEmpresaFlow] = useState(null)

  const fetchEmpresasSinConsultora = async (user) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/sinEmpresasView`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            user,
        })
    })
    const data = await res.json()
    return data
  }

  const fetchEmpresasById = async (user, idConsultora) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/empresasView`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user,
        idConsultora: parseInt(idConsultora)
      })
    });
    const data = await res.json()
    return data
  };

  const fetchEmpleadosById = async (user, idEmpresa) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/viewUserCompany`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            user: user,
            idEmpresa: parseInt(idEmpresa)
        })
    })
    const data = await res.json()
    return data
  }

  const handleModalEmpleado = (id) => {
    setIdEmpresaFlow(parseInt(id))
    setModalEmpleado(true)
  }
  
  const totalNodes = async () => {

    const empresasSinConsultoraRaw = await fetchEmpresasSinConsultora(USER)

    const empresasSinConsultora = empresasSinConsultoraRaw.objeto.map((e, i) => ({
        id: `empresa-${e.id_empresa}`,
        position: { x: 0, y: 100 }, // posición provisional
        data: { label: e.nombre },
        parentNode: '0',
        extent: 'parent',
        style: {
          backgroundColor: '#f8f9fa'
        }
    }))
  
    // Paso 1: Traer las empresas agrupadas por consultora
    const empresasNodesPerConsultora = await Promise.all(
      consultoras.map(async (consultora) => {
        const empresas = await fetchEmpresasById(USER, consultora.id_consultora);
        return {
          consultoraId: consultora.id_consultora.toString(),
          consultoraNombre: consultora.nombre,
          empresas: empresas.objeto.map((empresa, j) => ({
            id: `empresa-${empresa.id_empresa}`,
            position: { x: 0, y: 100 }, // provisional
            data: { label: empresa.nombre },
            parentNode: consultora.id_consultora.toString(),
            extent: 'parent',
            style: {
              backgroundColor: '#f8f9fa'
            }
          }))
        };
      })
    );

    if (empresasSinConsultora.length > 0) {
      empresasNodesPerConsultora.push({
        consultoraId: '0',
        consultoraNombre: 'Sin Consultora',
        empresas: empresasSinConsultora
      });
    }
  
    let offsetX = 0; // posición acumulada para cada grupo de consultora + empresas
  
    const consultoraNodes = empresasNodesPerConsultora.map(({ consultoraId, consultoraNombre, empresas }) => {
      const width = empresas.length * 170;
      const centerX = offsetX + width / 2 - 85; // centro visual (85 es mitad de 170)
  
      // Ajustar la posición de empresas para que queden dentro del rango visual correcto
      empresas.forEach((empresaNode, index) => {
        empresaNode.position.x = offsetX + index * 170;
      });
  
      // Acumular el espacio horizontal para la próxima consultora
      offsetX += width + 100; // +100 de separación entre grupos
  
      return {
        id: consultoraId,
        position: { x: centerX, y: 50 },
        data: { label: consultoraNombre },
        parentNode: 'parent',
        extent: 'parent',
        style: {
          backgroundColor: '#e6efff'
        }
      };
    });

    const empresaNodes = empresasNodesPerConsultora.flatMap(e => e.empresas);

    const empleadosNodesPerEmpresa = await Promise.all(
      empresaNodes.map(async (empresa) => {
        const idEmpresa = empresa.id.split('-')[1]
        const empleados = await fetchEmpleadosById(USER, idEmpresa)

        const empleadosNodes = empleados.objeto.map((empleado, i) => ({
          id: `empleado-${empleado.id_empleado}`,
          position: {
            x: empresa.position.x,
            y: (empresa.position.y + 50) + i * 50
          },
          data: { label: empleado.nombre },
          parentNode: empresa.id,
          extent: 'parent'
        }))

        const customNodeBtn = {
          id: `add-btn-${empresa.id}`,
          type: 'custom',
          position: {
            x: empresa.position.x,
            y: (empresa.position.y + 50) + empleadosNodes.length * 50
          },
          data: {
            label: '+ Agregar',
            onClick: () => handleModalEmpleado(idEmpresa)
          },
          parentNode: empresa.id,
          extent: 'parent'
        }

        return [empresa, ...empleadosNodes, customNodeBtn]
      })
    )

    const empresaYEmpleadosNodes = empleadosNodesPerEmpresa.flat();

    const parentNode = {
      id: 'parent',
      position: { x: offsetX / 2 - 85, y: 0 }, // Centrado horizontalmente
      data: { label: "Kiviu" },
      style: {
        backgroundColor: '#9ec5fe'
      }
    };
  
    const allNodes = [parentNode, ...consultoraNodes, ...empresaYEmpleadosNodes];
    setNodes(allNodes);
  };

  const totalEdges = async () => {
  
    const empresasEdgesPerConsultora = await Promise.all(
      consultoras.map(async (c) => {
        const empresas = await fetchEmpresasById(USER, c.id_consultora);
        return empresas.objeto.flatMap((e) => [
          // Consultora ➜ Empresa
          {
            id: `ce-${c.id_consultora}-${e.id_empresa}`,
            source: c.id_consultora.toString(),
            target: `empresa-${e.id_empresa}`,
          },
          // Empresa ➜ Botón  (+ Agregar)
          {
            id: `eb-${e.id_empresa}`,
            source: `empresa-${e.id_empresa}`,
            target: `add-btn-empresa-${e.id_empresa}`,
          },
        ]);
      })
    );
    const empresaEdges = empresasEdgesPerConsultora.flat();
  
    const empleadosEdgesPerEmpresa = await Promise.all(
      consultoras.map(async (c) => {
        const empresas = await fetchEmpresasById(USER, c.id_consultora);
        return Promise.all(
          empresas.objeto.map(async (empresa) => {
            const empleados = await fetchEmpleadosById(USER, empresa.id_empresa);
            return empleados.objeto.map((empleado) => ({
              id: `ee-${empresa.id_empresa}-${empleado.id_empleado}`,
              source: `empresa-${empresa.id_empresa}`,
              target: `empleado-${empleado.id_empleado}`,
            }));
          })
        );
      })
    );
    const empleadoEdges = empleadosEdgesPerEmpresa.flat().flat();
  
    const empresasSinConsultoraRaw = await fetchEmpresasSinConsultora(USER);
  
    const empresasSinConsultoraEdges = empresasSinConsultoraRaw.objeto.flatMap(
      (e) => [
        {
          id: `s0-${e.id_empresa}`,
          source: '0',
          target: `empresa-${e.id_empresa}`,
        },
        {
          id: `eb-${e.id_empresa}`,
          source: `empresa-${e.id_empresa}`,
          target: `add-btn-empresa-${e.id_empresa}`,
        },
      ]
    );
  
    const empleadosEdgesEmpresasSinConsultora = await Promise.all(
      empresasSinConsultoraRaw.objeto.map(async (empresa) => {
        const empleados = await fetchEmpleadosById(USER, empresa.id_empresa);
        return empleados.objeto.map((empleado) => ({
          id: `se-${empresa.id_empresa}-${empleado.id_empleado}`,
          source: `empresa-${empresa.id_empresa}`,
          target: `empleado-${empleado.id_empleado}`,
        }));
      })
    );
    const empleadoSinConsultoraEdges = empleadosEdgesEmpresasSinConsultora.flat();
  
    const consultorasEdges = [
      ...consultoras.map((c) => ({
        id: `cp-parent-${c.id_consultora}`,
        source: 'parent',
        target: c.id_consultora.toString(),
      })),
      { id: 'cp-parent-0', source: 'parent', target: '0' },
    ];

    const allEdges = [
      ...consultorasEdges,
      ...empresaEdges,
      ...empleadoEdges,
      ...empresasSinConsultoraEdges,
      ...empleadoSinConsultoraEdges
    ];
  
    setEdges(allEdges);
  };

  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const [edges, setEdges, onEdgesChange] = useEdgesState([])
 
  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );

  useEffect(()=>{
    fetchConsultoras(USER)
    totalNodes()
    totalEdges()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
 
  return (
    <>
      <flowchartContext.Provider value={{ idEmpresaFlow, fetchEmpleadosById, totalNodes }}>
        <ModalEmpleado show={modalEmpleado} onHide={()=>setModalEmpleado(false)}/>
        <div className='section__header d-flex flex-row align-items-end mb-4'>
          <i className='bi bi-people-fill me-2'></i>
          <h4 className='m-0'>Admin</h4>
        </div>
        {/* Flowchart */}
        <div className='flow border border-1'>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            nodeTypes={nodeTypes}
            onConnect={onConnect}
            onInit={(instance) => {
              instance.fitView({ minZoom: 0.7, maxZoom: 1 });
            }}
          >
            <Controls />
            <MiniMap />
            <Background variant="dots" gap={12} size={1} />
          </ReactFlow>
        </div>
      </flowchartContext.Provider>
    </>
  )
}

export default Flowchart